import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const PhoneFull = ({
  color = 'currentColor',
  height = 52,
  isColorInherited = false,
  width = 32,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 32 52" {...props}>
    <rect width="28" height="48" x="2" y="2" fill={getColor(color, isColorInherited)} rx="5" />
    <rect
      width="27"
      height="47"
      x="2.5"
      y="2.5"
      stroke={getColor(color, isColorInherited)}
      rx="4.5"
    />
  </SvgIcon>
);
